<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:left_view>
      <LeftPanelSpectrum ref='leftPanelSpectrum'></LeftPanelSpectrum>
    </template>
    <template v-slot:right_view>
      <div style="height: 140">
        <SpectrumTable ref='spectrumTable' :selectRecord='selectRecord' @getSpectrumData='getSpectrumData'></SpectrumTable>
      </div>
      <div class="h100-160 h-scroll">
        <SpectrumChart ref='spectrumChart'></SpectrumChart>
      </div>
    </template>
  </BasicLayout>
</template>

<script>
import SpectrumTable from '../../components/spectrumConfig/RightPanel/SpectrumTable';
import BasicLayout from '../../layouts/BasicLayout';
import LeftPanelSpectrum from '../../components/spectrumConfig/LeftPanel/LeftPanelSpectrum.vue';
import SpectrumChart from '../../components/spectrumConfig/RightPanel/SpectrumChart';

export default {
  name: 'SpectrumPage',
  components: {
    SpectrumChart,
    LeftPanelSpectrum,
    SpectrumTable,
    BasicLayout
  },
  data() {
    return {
      left: {
        show: true,
        name: this.$t('Spectrum.NElist')
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: this.$t('Spectrum.spectrum_manager')
      },
      netype: [
        'ibs',
        'enodeb',
        'bpdt'
      ],
      selectRecord: ''
    };
  },
  methods: {
    getNe(ne) {
      this.$refs.userstable.getGridData(ne);
    },
    getSpectrumData(params) {
      console(params);
    }
  }
};
</script>

<style scoped>

</style>
